module.exports = __webpack_public_path__ + "static/bkCube-37045b9dfdab5467ba397057266c7d92.jpg";